/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { ScreenTaskControllerTypes } from '../../../core/navigation/ScreenTaskControllerTypes';
import { setScreenTaskController } from '../../screens/screens.reducers';
import { OverlayTypes } from '../OverlayTypes';
import { VuLogger } from '../../../core/logging';
import { ErrorTypes } from '../../../core/error';
import { IOverlayDialog } from '../../overlaydialog/overlaydialogprops';
import { hideOverlayDialog, showOverlayDialog } from '../../overlaydialog/overlaydialog.reducers';
import { Locale } from '../../../core/locale/Locale';
import { LocaleKeys } from '../../../core/locale/LocaleKeys';

const GLOBAL_MOUSE_TRAP = 'hideNoNetworkOverlay';

export const showNoNetworkOverlay = () => (dispatch: Function, getState: Function) => {
    const { isActive: isAntiBurnActive } = getState().antiburnOsd;
    if (isAntiBurnActive) return;

    const { isOverlayDialogActive } = getState().overlayDialog;
    if (isOverlayDialogActive) dispatch(hideOverlayDialog());
    const overlayDialogProps: IOverlayDialog = {
        description: Locale.getString(LocaleKeys.NO_NETWORK_OVERLAY_DESCRIPTION),
        hasDimmer: true,
        hasSeperator: false,
        messageCode: ErrorTypes.NO_NETWORK_OVERLAY_ERROR_CODE,
        mouseTrapValue: GLOBAL_MOUSE_TRAP,
        options: [{ text: Locale.getString(LocaleKeys.OVERLAY_OPTION_OK_TEXT) }],
        overlayType: OverlayTypes.NO_NETWORK,
        title: Locale.getString(LocaleKeys.NO_NETWORK_OVERLAY_TITLE),
    };
    dispatch(setScreenTaskController(ScreenTaskControllerTypes.NO_NETWORK_OVERLAY));
    dispatch(showOverlayDialog(overlayDialogProps));
};

export const hideNoNetworkOverlay = () => (dispatch: Function, getState: Function) => {
    const { isOverlayDialogActive, uiProperties } = getState().overlayDialog;
    if (isOverlayDialogActive && uiProperties.overlayType === OverlayTypes.NO_NETWORK)
        dispatch(hideOverlayDialog());
};

export const onKeyOkNoNetworkOverlay = () => (dispatch: Function) => {
    VuLogger.logNoNetworkOverlayOkUserAction();
    dispatch(hideOverlayDialog());
};

export const onKeyBackNoNetworkOverlay = () => (dispatch: Function) => {
    VuLogger.logNoNetworkOverlayCancelUserAction();
    dispatch(hideOverlayDialog());
};

export const onMouseClickNoNetworkOverlay = () => (dispatch: Function, getState: Function) => {
    const { value } = getState().inputFactory;

    if (value === GLOBAL_MOUSE_TRAP) {
        dispatch(hideOverlayDialog());
        return;
    }
    dispatch(onKeyOkNoNetworkOverlay());
};
